// import './hot';
// import 'vant/es/notify/style'
// import 'vant/es/toast/style'

// import { createApp } from 'vue';
// import { createPinia } from 'pinia'
// import App from './App.vue';
// import { router } from './router/router';
// import { appConfig } from './appConfig';
// import { stat } from '@/common/util/statManager';
// import { getQueryParam } from './common/util/getUrlParam';

// const query = (key: string) => {
//     const value = getQueryParam(key) || window.sessionStorage.getItem(`query:${key}`);
//     value && window.sessionStorage.setItem(`query:${key}`, value);
//     return value;
// };

// window.isNotAuthModal = !!query('isNotAuthModal');

// async function render() {
//     const pinia = createPinia();
//     const app = createApp(App).use(pinia);
//     (process.env.NODE_ENV === 'development') && console.table({
//         title: '模版项目配置',
//         version: '1.0.0',
//         appConfig,
//     });

//     // 埋点相关逻辑
//     stat.setupPageEnterAndPageLeave(router);

//     app.use(router);
//     app.mount('#app');
//     return app;
// }

// render();

